import getApiClient from "../../../../shared/api";

export function fetchShootingDayLocations(filmId, shootingDayId) {
  return (dispatch) => {
    dispatch({
      type: "FETCH_SHOOTING_DAY_LOCATIONS",
      payload: getApiClient().get(`/film/${filmId}/ShootingDay/${shootingDayId}/Locations`),
    });
  };
}
